import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

// [수정] width를 50px -> 100%로 변경하고, 배경을 투명하게 설정
// [수정] hover와 focus 상태일 때 하늘색 배경 추가
const Input = styled.input`
  border: none;
  width: 100%;
  height: 100%;
  background: transparent; /* 평소에는 투명 */
  border-radius: 2px;
  box-shadow: inset 0 0 0 1px #cfe8ff;
  text-align: center;
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;

  /* 부드러운 색상 전환을 위한 트랜지션 (선택사항) */
  transition:
    background-color 0.2s ease,
    box-shadow 0.2s ease;

  /* 마우스 올렸을 때 */
  &:hover {
    background-color: #f0f8ff; /* 연한 하늘색 (AliceBlue) */
    cursor: text;
  }

  /* 입력 중일 때 (포커스) */
  &:focus {
    outline: none;
    background-color: #e3f2fd; /* 조금 더 진한 하늘색 */
    box-shadow: inset 0 0 0 1px #b7ddff;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

interface Props {
  placeholder?: string
  value?: string | number
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
  width?: string
  height?: string
  type?: string
}

const TableInput = (props: Props) => {
  const { value, onChange, onBlur, width, height, type } = props
  const [inputValue, setInputValue] = useState<string | number>(value || '')

  useEffect(() => {
    if (type === 'number' && value !== undefined) {
      const val = value.toString()
      const [integer, decimal] = val.split('.')
      // 빈 문자열이거나 숫자가 아닌 경우 처리 강화
      if (!integer) {
        setInputValue(value)
        return
      }
      const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      setInputValue(
        decimal ? `${formattedInteger}.${decimal}` : formattedInteger
      )
    } else {
      setInputValue(value || '')
    }
  }, [value, type])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value
    if (type === 'number') {
      val = val.replace(/,/g, '') // 기존의 콤마 제거

      // 빈 값일 때 처리 (다 지웠을 때 0이나 NaN이 되지 않도록)
      if (val === '') {
        setInputValue('')
        if (onChange) onChange(e)
        return
      }

      if (!isNaN(Number(val))) {
        const [integer, decimal] = val.split('.')
        const formattedInteger = Number(integer).toLocaleString() // 콤마 추가
        const formattedValue =
          decimal !== undefined
            ? `${formattedInteger}.${decimal}`
            : formattedInteger
        setInputValue(formattedValue)
        if (onChange) {
          // 부모에게 보낼 때는 콤마 없는 순수 숫자 값(또는 문자열)을 보내는 것이 일반적이지만,
          // 현재 로직상 e.target.value를 그대로 보내므로 유지합니다.
          // 필요하다면 여기서 val(콤마 없는 값)을 value로 덮어씌워 보낼 수 있습니다.
          const event = { ...e, target: { ...e.target, value: val } }
          onChange(event)
        }
        return
      }
    }
    setInputValue(val)
    if (onChange) {
      const event = { ...e, target: { ...e.target, value: val } }
      onChange(event)
    }
  }

  return (
    <Input
      // props로 width가 들어오면 그걸 쓰고, 아니면 100% (styled component 기본값) 사용
      style={{ width: width || '100%', height: height }}
      type="text"
      value={inputValue} // value가 0일때 0 출력, 없으면 '' (|| 0 제거 추천: 초기값이 0이면 0이 렌더링됨)
      onChange={handleChange}
      onBlur={onBlur}
    />
  )
}

export default TableInput
